import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Wrapper from '../components/Wrapper.js';
import Api from '../Api.js';
// import { getAgentList } from '../store/actions/agent';
import { Button, Form, Row, Col } from 'react-bootstrap';
import CustomPagination from '../components/BlueButton/CustomPagination.js';
import CustomLinesEllipsis from '../components/Mydata/CustomLinesEllipsis.js';
import LittleButton from '../components/BlueButton/LittleButton.js';
import { Autocomplete, TextField } from "@mui/material";
import Loader from '../components/BlueButton/Loader.js';

export default function AdminAgent() {
  const navigate = useNavigate();
  const [agentList, setAgentList] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);

  // Filter states
  const [filters, setFilters] = useState({
    start_date: '',
    end_date: '',
    company: [],
    agent: []
  });
  const [companies, setCompanies] = useState([]);
  const [agents, setAgents] = useState([]);

  const isAdmin = useSelector((state) => state.manager.employee);
  const dispatch = useDispatch();

  const fetchTasks = async () => {
    const { data } = await Api.getUnpaidCompletedTasks(filters)
    setAgentList(data.results)
    setCount(data.count)
  }

  const fetchCompanies = async () => {
    try {
      const { data } = await Api.getCompaniesTitle()
      setCompanies(data.companies)
    } catch (error) {
      console.error('Error fetching companies:', error)
    }
  }

  const fetchAgents = async () => {
    try {
      const { data } = await Api.gerAgentList()
      setAgents(data.results || data)
    } catch (error) {
      console.error('Error fetching agents:', error)
    }
  }

  useEffect(() => {
    if (isAdmin && isAdmin?.user_id !== 86 && isAdmin?.user_id !== 1734 && isAdmin?.user_id !== 2) {
      navigate("/")
    } else {
      fetchCompanies()
      fetchAgents()
      fetchTasks()
    }
  }, [isAdmin, page, filters])

  const handlePay = async (id) => {
    try {
      const { data } = await Api.setAgentTaskPurchasesPayed(id)
      alert(data.message)
      // Refresh the list after payment
      fetchTasks()
    } catch (error) {
      console.error('Error marking purchases as paid:', error)
      alert('Error marking purchases as paid')
    }
  }

  const handleReject = async (id, taskTitle) => {
    const reason = prompt(`Մերժելու պատճառը (${taskTitle}):`)
    if (reason === null) return; // User clicked cancel
    
    try {
      await Api.rejectAgentTask(id, { reason })
      alert('Առաջադրանքը մերժված է')
      // Refresh the list after rejection
      fetchTasks()
    } catch (error) {
      console.error('Error rejecting task:', error)
      const errorMsg = error?.response?.data?.error || 'Չհաջողվեց մերժել առաջադրանքը'
      alert(errorMsg)
    }
  }

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }))
  }

  const handleClearFilters = () => {
    setFilters({
      start_date: '',
      end_date: '',
      company: [],
      agent: []
    })
  }

  return (
    <Wrapper>
      {/* Filter Section */}
      <div className='w-100'>
        <div className="w-100 mb-4" style={{ padding: '20px', borderRadius: '8px' }}>
          <h5 className="mb-3">Ֆիլտրեր</h5>
          <Row>
            <Col md={3} className="mb-3">
              <Form.Group>
                <Form.Label>Սկիզբ</Form.Label>
                <Form.Control
                  type="date"
                  value={filters.start_date}
                  onChange={(e) => handleFilterChange('start_date', e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={3} className="mb-3">
              <Form.Group>
                <Form.Label>Վերջ</Form.Label>
                <Form.Control
                  type="date"
                  value={filters.end_date}
                  onChange={(e) => handleFilterChange('end_date', e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={3} className="mb-3">
              <Form.Group>
                <Form.Label>Կազմակերպություն</Form.Label>
                <Autocomplete
                  multiple
                  loading={companies.length <= 0}
                  loadingText={<div className="auto-complete-loader"><Loader size={15} /></div>}
                  id="company-autocomplete"
                  options={companies}
                  value={companies.filter(c => filters.company.includes(c.id))}
                  onChange={(e, value) => {
                    handleFilterChange('company', value.map(v => v.id))
                  }}
                  getOptionLabel={(option) => option.name || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Բոլորը"
                      variant="outlined"
                      size="small"
                    />
                  )}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                />
              </Form.Group>
            </Col>
            <Col md={3} className="mb-3">
              <Form.Group>
                <Form.Label>Պատասխանատու</Form.Label>
                <Autocomplete
                  multiple
                  loading={agents.length <= 0}
                  loadingText={<div className="auto-complete-loader"><Loader size={15} /></div>}
                  id="agent-autocomplete"
                  options={agents}
                  value={agents.filter(a => filters.agent.includes(a.id))}
                  onChange={(e, value) => {
                    handleFilterChange('agent', value.map(v => v.id))
                  }}
                  getOptionLabel={(option) => {
                    return `${option.user?.first_name || ''} ${option.user?.last_name || ''}`.trim() || 'N/A'
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Բոլորը"
                      variant="outlined"
                      size="small"
                    />
                  )}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                />
              </Form.Group>
            </Col>
          </Row>
          <LittleButton
            buttonStyle="blue-button"
            onChangeValue={handleClearFilters}
            title="Մաքրել ֆիլտրերը"
          />
        </div>

        {/* Task List Section */}
        <div className="flex-wrap w-100 d-flex flex-row">

          {agentList.length > 0 ? agentList.map((item) => (
            <Col md={6} className="agent-pay-item" key={item.id}>
              <h5>{item.title}</h5>
              <CustomLinesEllipsis text={item?.description} maxLines={2} />
              <p>Կազմակերպություն - {item.company?.name}</p>
              <p>Պատասխանատու - {item.assigned_to?.user?.first_name} {item.assigned_to?.user?.last_name}</p>
              <p>Տեսակ - {item.task_type?.name}</p>
              <p>{item.purchases_total} ֏</p>
              <div style={{ display: 'flex', gap: '10px' }}>
                <Button 
                  style={{ border: "1px solid #187097", backgroundColor: '#187097', color: 'white' }} 
                  variant="contained" 
                  onClick={() => handlePay(item.id)}
                >
                  Վճարել
                </Button>
                <Button 
                  style={{ border: "1px solid #dc3545", backgroundColor: '#dc3545', color: 'white' }} 
                  variant="contained" 
                  onClick={() => handleReject(item.id, item.title)}
                >
                  Մերժել
                </Button>
              </div>
            </Col>
          )) : "Առաջադրանքներ չկան կամ բեռնվում է"}
        </div>
        {count > 10 && (
          <div className="d-flex justify-content-center">
            <CustomPagination
              currentPage={page}
              totalItems={count}
              itemsPerPage={10}
              totalPages={Math.ceil(count / 10) || 0}
              onPageChange={(newPage) => setPage(newPage)}
            />
          </div>
        )}
      </div>
    </Wrapper>
  )
}
